'use client';

import type { PlayerInterface } from '@frameio/media-viewer/hooks/usePlayer/types';
import { usePremierePlayheadSync } from '../hooks/usePremierePlayheadSync';

export function PremierePlayheadSync({
  playerInterface,
}: {
  playerInterface: PlayerInterface;
}) {
  usePremierePlayheadSync({ playerInterface });
  return null;
}
